<template>
    <v-card>
        <v-card-title class="justify-center">
            <v-btn icon style="position: absolute; left: 1em;" @click="$emit('fechar')">
                <v-icon>close</v-icon>
            </v-btn>
            <h1>CONFIGURAÇÕES SENDZAPI</h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-alert v-model="alerta.ativo" :type="alerta.tipo" style="width: 100%;">
            {{ alerta.texto }}
        </v-alert>
        <v-card-text class="justify-center text-xs-center">
            <template v-if="qrcode">
                <v-img :src="qrcode"></v-img>
                <v-btn color="success" @click="confirmarConexao">Já li o Qrcode</v-btn>
            </template>
            <template v-else-if="!loading">
                <h2 class="success--text">Você já possui um conexão em um dispositivo</h2>
                <v-btn class="mt-4" color="error" @click="interromperConexao">Interromper conexão</v-btn>
            </template>
            <template v-else>
                <v-progress-circular
                    indeterminate
                    :size="50"
                    color="info"
                ></v-progress-circular>
            </template>
            <v-spacer></v-spacer>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        qrcode: undefined,
        alerta: {
            tipo: 'error',
            texto: 'Esse tipo de veículo já foi cadastrado',
            ativo: false
        }
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        },
        smartLock () {
            return this.$store.getters.smartLock
        }
    },
    beforeMount () {
        this.estabelecerConexao()
    },
    methods: {
        estabelecerConexao () {
            this.qrcode = undefined
            this.$store.dispatch('sendZapi', {
                method: 'GET'
            }).then(json => {
                this.qrcode = json.base64
            })
        },
        confirmarConexao () {
            this.$store.dispatch('sendZapi', {
                method: 'PUT'
            }).then(() => {
                this.qrcode = undefined
            })
        },
        interromperConexao () {
            this.$store.dispatch('sendZapi', {
                method: 'DELETE'
            }).then(() => {
                this.qrcode = undefined
                this.estabelecerConexao()
            })
        }
    }
}
</script>

<style>

</style>
